import React from 'react'
import context from '@/context'
import { connect } from 'react-redux'
import { actionCreators } from '@/store/workflowDefinition'
import { localized } from '@/decorators/localized'
import { Row, Col, Label } from 'reactstrap'
import { GridColumn as Column } from '@progress/kendo-react-grid'
import { BsrsGrid, DateCell, DateFilterCell, actionButtonsColumnProps } from '@/components/BsrsGrid'
import { Main, MainTop, MainTopTitle, MainBody, WhiteBox } from '@/components/Layout'
import Resx from '@/components/Resx'
import getEnumTranslation from '@/enums/enums'
import { workflowDefinitionType } from '@/enums/workflowDefinitionType'
import LoadingIndicator from '@/components/LoadingIndicator'
import { WorkflowVersionCell } from '@/components/BsrsGrid/BsrsGrid.WorkflowVersionCell'
import { decodeVersionString } from '@/utils/versionConverter'

@localized()
class WorkflowDefinitionDetail extends React.Component {
  getId = () => this.props.match.params.id
  componentDidMount () {
    this.reload()
  }
  reload () {
    this.props.get(this.getId())
  }
  renderBody () {
    const { workflowDefinition, localize } = this.props
    if (workflowDefinition.fetching === true || workflowDefinition.workflowDefinition === null) { return <LoadingIndicator /> }
    const enumName = workflowDefinitionType.enumName
    const entity = workflowDefinition.workflowDefinition
    return (
      <React.Fragment>
        <WhiteBox>
          <Row>
            <Col lg='6'>
              <Label><Resx name='Common.Code' />: </Label>
              <span className='ml-2'>{entity.code}</span>
            </Col>
          </Row>
          <Row>
            <Col lg='6'>
              <Label><Resx name='Common.AllowManualExecution' />: </Label>
              <span className='ml-2'>{entity.allowManualExecution === true ? <Resx name='Common.Yes' /> : <Resx name='Common.No' />}</span>
            </Col>
          </Row>
          <Row>
            <Col lg='6'>
              <Label><Resx name='Common.Version' />: </Label>
              <span className='ml-2'>{decodeVersionString(entity.version)}</span>
            </Col>
          </Row>
          <Row>
            <Col lg='6'>
              <Label><Resx name='Common.Type' />: </Label>
              <span className='ml-2'>{getEnumTranslation({ localize, enumName, value: entity.workflowDefinitionType })}</span>
            </Col>
          </Row>
        </WhiteBox>
        <BsrsGrid
          persistenceId={'workflow-definition-version-list'}
          dataSource={req => context.api.workflowDefinitionService.getWorkflowDefinitionVersionTableData(this.getId(), req)}
          filterable>
          <Column field='version' cell={WorkflowVersionCell()} title={localize('Common.Version')} editable={false} filtrable={false} />
          <Column field='name' title={localize('Common.ArabicName')} editable={false} />
          <Column field='latinName' title={localize('Common.LatinName')} editable={false} />
          <Column field='creationTime' title={localize('Common.CreationTime')} cell={DateCell} filterCell={DateFilterCell} editable={false} />
          <Column {...actionButtonsColumnProps(dataItem => [{
            url: x => `/workflow-configuration/${this.getId()}/version/${x.id}`,
            icon: 'show'
          }])} />
        </BsrsGrid>
      </React.Fragment>
    )
  }
  render () {
    return (
      <Main>
        <MainTop>
          <MainTopTitle backUrl={`/workflow-configuration`}><Resx name='Common.WorkflowConfiguration' /></MainTopTitle>
        </MainTop>
        <MainBody>
          {this.renderBody()}
        </MainBody>
      </Main>
    )
  }
}

function mapStateToProps (state) {
  return {
    workflowDefinition: state.workflowDefinition
  }
}

const mapDispatchToProps = {
  get: actionCreators.get
}

export default connect(mapStateToProps, mapDispatchToProps)(WorkflowDefinitionDetail)



// WEBPACK FOOTER //
// ./src/internal-app/pages/administration/workflow-configuration/detail.js